
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host li {
  margin-bottom: 1.5rem;
}
  :host li {
  display: flex;
}
  :host li {
  align-items: baseline;
}
  :host li {
  gap: 0.5rem;
}
  :host li{
    color:var(--gray-professional-lighten-1);
  }

.card-links {
  margin: 0px;
  align-self: center;
  font-weight: var(--fw-medium);
  line-height: 1.25rem;
}

::slotted(.card-link-item){
  text-decoration:none;
  color:var(--gray-professional-lighten-1);
  display:inline-block;
  margin-right:5px;
}

::slotted(.card-link-item:hover){
  text-decoration:underline;
  color:var(--gray-professional-lighten-1);
}
`;